var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WithDisposable } from '@blocksuite/lit';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { moreOperations } from './config.js';
let BookmarkOperationMenu = class BookmarkOperationMenu extends WithDisposable(LitElement) {
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        const menuItems = repeat(moreOperations.filter(({ showWhen = () => true }) => showWhen(this.model)), ({ type }) => type, ({ type, icon, label, action, divider, disableWhen = () => false }) => {
            return html `<icon-button
            width="126px"
            height="32px"
            class="menu-item ${type}"
            text=${label}
            ?disabled=${disableWhen(this.model)}
            @click=${() => {
                action(this.model, this.onSelected, this)?.catch(console.error);
            }}
          >
            ${icon}
          </icon-button>
          ${divider ? html `<div class="divider"></div>` : nothing} `;
        });
        return html `<div class="bookmark-operation-menu">${menuItems}</div> `;
    }
};
BookmarkOperationMenu.styles = css `
    .bookmark-operation-menu {
      border-radius: 8px;
      padding: 8px;
      background: var(--affine-background-overlay-panel-color);
      box-shadow: var(--affine-shadow-2);
    }
    .menu-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .menu-item:hover {
      background: var(--affine-hover-color);
    }
    .menu-item:hover.delete {
      background: var(--affine-background-error-color);
      color: var(--affine-error-color);
    }
    .menu-item:hover.delete > svg {
      color: var(--affine-error-color);
    }
    .menu-item svg {
      margin: 0 8px;
    }
  `;
__decorate([
    property({ attribute: false })
], BookmarkOperationMenu.prototype, "model", void 0);
__decorate([
    property({ attribute: false })
], BookmarkOperationMenu.prototype, "onSelected", void 0);
__decorate([
    property({ attribute: false })
], BookmarkOperationMenu.prototype, "std", void 0);
BookmarkOperationMenu = __decorate([
    customElement('bookmark-operation-menu')
], BookmarkOperationMenu);
export { BookmarkOperationMenu };
//# sourceMappingURL=bookmark-operation-popper.js.map